import { useNavigate } from 'react-router-dom';
import { useLogout, useMe } from '../api/queries';
import { homeFor } from '../auth/guards';
import { PasswordForm } from '../components/PasswordForm';
import { t } from '../i18n/pt-BR';

/**
 * Troca obrigatória: a senha atual é provisória. Tela própria, sem menu, para todos os perfis
 * (o operador não tem as telas de PCP, mas precisa poder trocar a senha).
 */
export function ForcedPasswordPage() {
  const { data: me } = useMe();
  const navigate = useNavigate();
  const logout = useLogout();
  if (!me) return null;

  return (
    <div className="login">
      <div className="login-card">
        <img className="logo" src="/acg-logo.png" alt={t.app.logoAlt} width={126} height={72} />
        <div>
          <h1>{t.password.forcedTitle}</h1>
          <p className="hint" style={{ marginTop: 8 }}>
            {t.password.forcedText}
          </p>
        </div>
        <PasswordForm
          submitLabel={t.password.continue}
          onDone={() => navigate(homeFor(me.perfil), { replace: true })}
        />
        <button
          type="button"
          className="link"
          onClick={() => logout.mutate(undefined, { onSettled: () => navigate('/login', { replace: true }) })}
        >
          {t.auth.logout}
        </button>
      </div>
    </div>
  );
}
